import { render, staticRenderFns } from "./ProJects.vue?vue&type=template&id=0c69efde&scoped=true"
import script from "./ProJects.vue?vue&type=script&lang=js"
export * from "./ProJects.vue?vue&type=script&lang=js"
import style0 from "./ProJects.vue?vue&type=style&index=0&id=0c69efde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c69efde",
  null
  
)

export default component.exports